import { create } from 'zustand';

const useLangStore = create((set) => ({
  lang: document.cookie.split(';').find((cookie) => cookie.includes('locale'))?.split('=')[1] ? document.cookie.split(';').find((cookie) => cookie.includes('locale'))?.split('=')[1] : 'ca_ES',
  setLang: (lang) => set({ lang }),
  alertOpen: false,
  setAlertOpen: (alertOpen) => set({ alertOpen }),
}))

export default useLangStore;